const DEFAULT_FONT_FACE = 'Arial';
const DEFAULT_TEXT_COLOR = '000000';
const HYPERLINK_COLOR = '0000FF';

export function createTextObject(text: string, fontSize: number, bold: boolean = false, italic: boolean = false): any {
    return {
        text,
        options: {
            fontSize,
            bold,
            italic,
            fontFace: DEFAULT_FONT_FACE,
            color: DEFAULT_TEXT_COLOR
        }
    };
}

export function createHyperlinkObject(text: string, url: string, fontSize: number): any {
    return {
        text,
        options: {
            fontSize,
            hyperlink: { url },
            fontFace: DEFAULT_FONT_FACE,
            color: HYPERLINK_COLOR,
            underline: true
        }
    };
}
